import React from 'react';

import {
  type UseIndoorClimateScoresParams,
  useIndoorClimateScores,
} from '../../hooks/useIndoorClimateScores';

import { IndoorClimateCard } from './IndoorClimateCard';

export const IndoorClimateCardContainer: React.FC<
  UseIndoorClimateScoresParams & { href?: string }
> = ({ href, ...params }) => {
  const { scores, isLoading, isError, isEmpty, retry } =
    useIndoorClimateScores(params);

  return (
    <IndoorClimateCard
      scores={scores}
      isLoading={isLoading}
      isError={isError}
      isEmpty={isEmpty}
      onRetry={retry}
      href={href}
    />
  );
};
